import type {components} from '@freckle/educator-entities/ts/curricula-api/generated-client'
import {curriculaClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type DecodableInfoT = components['schemas']['Decodable']

export const fetchDecodableInfos = (): Promise<Array<DecodableInfoT>> =>
  curriculaClient.GET('/decodables.json').then(extractData)
